import { Label, Row } from 'hatch-components';
import styled from 'styled-components';

export const StyledObservesDaylightSavingsTimeRow = styled(Row)(
  ({ theme: { spacing } }) => ({
    alignItems: 'center',
    marginBottom: spacing.md,
  }),
);

export const StyledObservesDaylightSavingsTimeLabel = styled(Label)(
  ({ theme: { spacing } }) => ({
    padding: `0 0 0 ${spacing.sm}`,
  }),
);
